import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetCallUsHoursOptions = gql`
  query GetCallUsHoursOptions {
    callUsPage {
      ... on CallUsPageSuccess {
        __typename
        holidayMessage
        options {
          __typename
          id
          title
          message
        }
      }
      ... on CallUsPageError {
        ...error
      }
    }
  }
  ${error}
`;

export default GetCallUsHoursOptions;
